import React from 'react';
import TransactionAntigoonScreen from "./TransactionAntigoonScreen";
import {fetchAntigoonTransaction} from "../../services";
import {useGenericItemLoader} from "../../hooks/useGenericItemLoader";

const TransactionAntigoonScreenWrapper = () => {
    const transaction = useGenericItemLoader(fetchAntigoonTransaction, 'transactionAntigoon');

    return (
        <TransactionAntigoonScreen transaction={transaction}/>
    );
};

export default TransactionAntigoonScreenWrapper;
